export default {
  data() {
    return {
      settings: {
        sendLabel: 'login',
      },
      groups: {
        login: {
          visible: true,
          fields: {
            username: {
              type: 'text',
              model: null,
              label: 'username_email',
              placeholder: 'username_email',
              rules: 'required',
            },
            password: {
              type: 'password',
              model: null,
              label: 'password',
              placeholder: 'password',
              // rules: 'required',
            },
            remember: {
              type: 'checkbox',
              model: null,
              id: 'remember_me',
              label: 'remember_me',
              placeholder: 'remember_me',
            },
          },
        },
      },
    };
  },
  methods: {
    init() {

    },
    async callback() {
      const loggedIn = await this.$store.dispatch('login', {
        username: this.groups.login.fields.username.model,
        password: this.groups.login.fields.password.model,
      });
      if (loggedIn) {
        await this.$store.dispatch('loadCustomerData');
        this.$router.push('/');
      }
    },
  },
};
